import request from '@/found/utils/request';
import Form from '@/found/components/form/form.vue';

export default {
  extends: Form,
  data() {
    return {
      formFunctionCode: 'main_form',
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  created() {
  },
  methods: {
    async formComplete() {
      await this.loadData();
    },
    async loadData() {
      if (this.formConfig.row && this.formConfig.row.id) {
        const { result } = await request.get(
          '/cps/v1/memberUserFeedback/findById',
          {
            id: this.formConfig.row.id,
          },
        );
        if (!result) return;
        this.setValue({
          ...result,
          feedbackPic: result.feedbackPic ? result.feedbackPic.split(';') : [],
        });
      }
    },
    /**
     * 设置自定义配置信息
     * @param {object} item 获取配置信息
     * @returns {object} v 返回自定义配置信息
     */
    setRule(item) {
      const v = item;
      v.props.formConfig = this.formConfig;
      v.props.fApi = this.fApi;
      return v;
    },

    /**
     * 提交表单
     */
    async submit() {
      const { code } = this.formConfig;
      const formData = this.getFormData();
      if (!formData) return;
      if (code === 'add') {
        await request.post('', formData);
      } else {
        formData.id = this.formConfig.row.id;
        await request.post('', formData);
      }
      this.$message({
        type: 'success',
        message: '操作成功',
      });
      this.$emit('onClose');
      this.$emit('onGetList');
    },
  },
};
